import { Box, Text, TextSize } from '@wix/design-system';
import { ChevronRight } from '@wix/wix-ui-icons-common';
import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { appRoutes } from '../../../react-router';
import { classNames } from '../../../util';
import { biHelpCenter } from '../../../util/bi';
import { CategoryItemType } from '../../api/getCategories';
import { homepageService } from '../../services/homepage/homepageService';
import s from './CategoryItem.scss';

type CategoryItemProps = {
  category: CategoryItemType;
  index: number;
};

const TEXT_SIZE: TextSize = homepageService.homepageEnabled
  ? 'medium'
  : 'small';

export const getLinkPath = (categoryId: string, searchParams) => {
  return {
    pathname: appRoutes.categoryById({
      categoryId,
    }),
    search: searchParams.toString(),
  };
};

export const CategoryItem: React.FC<CategoryItemProps> = ({
  category,
  index,
}) => {
  const [searchParams] = useSearchParams();

  const logCategoryClicked = React.useCallback(() => {
    biHelpCenter.logCategoriesInteraction(category, index);
  }, [category, index]);

  const className = classNames([
    s.categoryLink,
    index === 0 && s.categoryLinkFirstItem,
    homepageService.homepageEnabled && s.categoryLinkWithHomepage,
  ]);

  return (
    <Link
      className={className}
      to={getLinkPath(category.id, searchParams)}
      onClick={logCategoryClicked}
    >
      <Box align="space-between" verticalAlign="middle">
        <Text size={TEXT_SIZE} weight="thin" dataHook="category-item__title">
          {category.name}
        </Text>
        <ChevronRight color="#000" />
      </Box>
    </Link>
  );
};
